import React from 'react'
import { Form } from 'react-bootstrap'

type Props = Omit<
    React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'onChange' | 'value'
> & {
    value?: string
    onChange?: (value: string) => void
    isInvalid?: boolean
    autofocus?: boolean
    plaintext?: boolean
    className?: string
}

const TextareaInput = ({
    value,
    onChange,
    isInvalid,
    autofocus,
    placeholder,
    tabIndex,
    readOnly,
    plaintext,
    disabled,
    className,
}: Props) => {
    const handleChange = (value: string) => {
        if (onChange) {
            onChange(value)

            return
        }
    }

    return (
        <Form.Control
            as="textarea"
            autoFocus={autofocus}
            className={className}
            disabled={disabled}
            isInvalid={isInvalid}
            placeholder={placeholder}
            plaintext={plaintext}
            readOnly={readOnly}
            tabIndex={tabIndex}
            type="text"
            value={value ?? ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e.target.value)}
        />
    )
}

export default TextareaInput
